// extracted by mini-css-extract-plugin
export default {"Root":"MarkdownPage_Root__7JX0s","Embedded-Content":"MarkdownPage_Embedded-Content__y5vut"};